// Role Types - Detailed Descriptions
// Source: pf.framework.diagnostic.role.types

export const roleTypesData = {
  encodedId: 'pf.framework.diagnostic.role.types',
  title: 'Role Types',
  description: 'Three primary role types that engage with prioritization at different organizational levels.',
  
  roles: [
    {
      roleType: 'Individual Contributor',
      description: 'A team member focused on executing work and delivering results. Individual Contributors (ICs) own their personal prioritization while responding to team and organizational signals. They contribute frontline insights upward and adapt to changing priorities based on direction from Team Leads and leadership.'
    },
    {
      roleType: 'Team Lead / Manager',
      description: 'A leader responsible for a team\'s performance, resource allocation, and alignment. Team Leads balance their own individual contributor work with leadership responsibilities. They facilitate team prioritization conversations, arbitrate conflicts, translate organizational priorities into actionable team focus, and synthesize signals flowing both up and down the organizational hierarchy.'
    },
    {
      roleType: 'Executive / Org Leader',
      description: 'A senior leader who sets organizational direction and manages strategic trade-offs. Executives prioritize across strategic initiatives, time horizons, and competing organizational needs. They engage with teams through steering mechanisms and skip-level feedback, set and evolve organizational priorities, and make decisions that affect the entire organization or significant portions of it.'
    }
  ]
};

export default roleTypesData;
